import React from 'react'
import { Link, graphql } from 'gatsby'
import styled from '@emotion/styled'

import { media } from '../../../styles/variables'
import { Paragraph, ParagraphComponent } from '../types'
import Container from '../../Container'
import Row from '../../Row'
import Media from '../../Media'

interface PromotedItemsParagraph extends Paragraph {
	field_top_margin: number
	relationships: {
		field_node_multiple: any[]
	}
}

const PromotedItems: ParagraphComponent<PromotedItemsParagraph> = ({ className, paragraph }) => (
	<section css={{ marginTop: `${paragraph.field_top_margin}px` }} className={className}>
		<Container>
			<Row>
				{paragraph.relationships.field_node_multiple.map(node => (
					<div
						key={node.drupal_internal__nid}
						className="item"
						css={{ boxShadow: paragraph.field_top_margin ? '0px -4px 10px 5px rgba(0, 0, 0, 0.4)' : 'none' }}
					>
						<Link to={node.path.alias}>
							<Media source={node.relationships.field_media} />
							<div className="body">
								<h2>{node.title}</h2>
							</div>
						</Link>
					</div>
				))}
			</Row>
		</Container>
	</section>
)

export default styled(PromotedItems)`
	${Row} {
		flex-direction: column;
	}

	${media.up('md')} {
		${Row} {
			flex-direction: row;
		}
	}

	.item {
		background-color: var(--clr-primary);
		color: #fff;
		padding: 2px;
		margin-bottom: var(--spacing);
		flex: 1 1 0px;
	}

	.body {
		padding: var(--spacing-sm);
	}

	h2 {
		color: #fff;
	}
`

export const query = graphql`
	fragment PromotedItemsParagraph on paragraph__promoted_items {
		drupal_internal__id
		field_top_margin: field_number
		relationships {
			field_node_multiple {
				__typename
				... on node__article {
					drupal_internal__nid
					title
					path {
						alias
					}
					relationships {
						field_media {
							...MediaImageTeaser
						}
					}
				}
				... on node__donation_page {
					drupal_internal__nid
					title
					path {
						alias
					}
					relationships {
						field_media {
							...MediaImageTeaser
						}
					}
				}
				... on node__form {
					drupal_internal__nid
					title
					path {
						alias
					}
					relationships {
						field_media {
							...MediaImageTeaser
						}
					}
				}
				... on node__naalisivu {
					drupal_internal__nid
					title
					path {
						alias
					}
					relationships {
						field_media {
							...MediaImageTeaser
						}
					}
				}
				... on node__page {
					drupal_internal__nid
					title
					path {
						alias
					}
					relationships {
						field_media {
							...MediaImageTeaser
						}
					}
				}
			}
		}
	}
`
